<div class="page-content">
    <app-header></app-header>
    <app-home></app-home>
    <app-about></app-about>
    <app-my-services></app-my-services>
    <app-skills></app-skills>
    <app-curriculum-vitae></app-curriculum-vitae>
    <app-projects></app-projects>
    <!-- <app-references></app-references> -->
    <app-contact></app-contact>
    <footer class="footer" >
        <p> Copyright ©<span>{{currentYear}}</span> By Abdul Rehman</p>
    </footer>
</div>